import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import { setLoading } from "@/store/slices/feedback";
import { useParams, useNavigate } from "react-router-dom";
import Message from "@/components/Message";
import { createNewWait } from "@/apis";
import confirmationIcon from "../../assets/confirmation.svg";
import arrowIcon from "../../assets/return_icon.svg";
import { updateEditValue } from "@/store/slices/waitlist";
import { ClientButton } from "@/components/button";
import useCRM from "@/hooks/useCRM";

const useStyles = makeStyles({
  root: {},
  name: {
    fontSize: "20px",
    fontFamily: "Roboto",
    color: "#fff",
    textAlign: "center",
    paddingBottom: 31,
  },
  back: {
    position: "absolute",
    left: 17,
    top: 28,
    color: "white",
    fontSize: 27,
    cursor: "pointer",
  },
  contentWrapper: {
    padding: "0 16px 41px",
  },
  paper: {
    minHeight: 592,
    padding: "19px 19px",
  },
  infoBx: {
    textAlign: "center",
  },
  contactName: {
    fontSize: 18,
    fontWeight: 500,
  },
  buttonBox: {
    margin: "46px auto",
    width: "max-content",
  },
  button: {
    width: 261,
  },
  icon: {
    width: 95,
    height: 118,
    margin: "161px auto",
    marginBottom: 20,
  },
  iconImg: {
    width: 95,
    height: 118,
  },
});

export default ({}) => {
  const classes = useStyles();
  const { merchantId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const merchant = useSelector((state) => state.merchant);
  const newWait = useSelector((state) => state.waitlist.edit.value);
  const { name, phone, partySize } = newWait;
  const { isCRMOpen, checkCRMMember } = useCRM(merchantId, "client");

  const onConfirm = async () => {
    try {
      dispatch(setLoading(true));
      const newWaitData = { ...newWait, phone: phone.replace(/\D/g, "") };
      const res = await createNewWait(merchantId, newWaitData);
      const { waitId } = res.data;
      let isNavigateToCRM = false;
      // 1. 判断是否开通crm
      if (isCRMOpen) {
        // 2. 判断是否已经是会员
        isNavigateToCRM = !(await checkCRMMember(phone));
      }
      const nextPage = window.location.pathname.replace(
        /\/[^\/]*$/,
        `/${isNavigateToCRM ? "crmLogin" : "waitingNumber"}?id=${waitId}`
      );
      navigate(nextPage);
    } catch (err) {
      if (err?.response) {
        const {
          data: { description },
        } = err.response;
        Message.error({ content: description });
        return;
      }
      Message.error({ content: err.message });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const onBack = async () => {
    dispatch(updateEditValue({ partySize: "", name: "", phone: "" }));
    navigate(`/${merchantId}/client`);
  };

  return (
    <div>
      <div onClick={onBack} className={classes.back}>
        <img src={arrowIcon} />
      </div>
      <div className={classes.name}>{merchant ? merchant.name : ""}</div>
      <div className={classes.contentWrapper}>
        <Paper className={classes.paper}>
          <div className={classes.infoBx}>
            <div className={classes.icon}>
              <img className={classes.iconImg} src={confirmationIcon} />
            </div>
            <div className={classes.contactName}>{name}</div>
            <div>{phone}</div>
            <div>{`Party of ${partySize}`}</div>
          </div>
          <div className={classes.buttonBox}>
            <ClientButton
              onClick={onConfirm}
              background="#FFA439"
              textcolor="#fff"
            >
              Confirm
            </ClientButton>
          </div>
        </Paper>
      </div>
    </div>
  );
};
